import React from 'react';
import { FadeIn } from './FadeIn';
import { Lock, Download } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
export function Offer() {
  return <section id="offer" className="py-24 md:py-32 bg-gradient-to-b from-[#0B1029] to-[#1A2352] relative overflow-hidden scroll-mt-16" data-id="element-170">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#F5D0A9]/10 via-transparent to-transparent -z-10" data-id="element-171" />

      <div className="container mx-auto px-6 max-w-4xl text-center" data-id="element-172">
        <FadeIn data-id="element-173">
          <div className="bg-[#0B1029]/80 backdrop-blur-xl p-8 md:p-16 rounded-[2.5rem] border border-[#F5D0A9]/20 shadow-[0_0_80px_rgba(245,208,169,0.07)]" data-id="element-174">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-white mb-6 leading-tight" data-id="element-175">
              Reclaim your rest for less than the cost of a bottle of useless
              sleep gummies.
            </h2>
            <p className="text-xl text-slate-300 mb-12 font-light max-w-2xl mx-auto" data-id="element-176">
              No subscriptions or hidden fees. Just a biological blueprint to
              finally stop the 3:00 AM panic.
            </p>

            <div className="mb-12" data-id="element-177">
              <div className="flex items-center justify-center gap-4 mb-3" data-id="element-178">
                <span className="text-4xl md:text-5xl font-serif text-slate-500 line-through decoration-2" data-id="element-179">
                  $19
                </span>
                <span className="text-xs font-medium tracking-widest uppercase text-[#F2A68D] bg-[#F2A68D]/10 px-3 py-1.5 rounded-full border border-[#F2A68D]/20" data-id="element-180">
                  66% Off
                </span>
              </div>
              <p className="text-2xl md:text-3xl font-serif text-white" data-id="element-181">
                Get yours today for{' '}
                <span className="text-[#F5D0A9] font-medium" data-id="element-182">$6.39</span>
              </p>
            </div>

            <a href="https://plenavital.com/cart/48365497024737:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart({
            content_name: 'The 3:00 AM Sleep Fix',
            content_ids: ['48365497024737'],
            content_type: 'product',
            value: 6.39,
            currency: 'USD'
          })} className="w-full md:w-auto bg-[#F5D0A9] text-[#0B1029] px-12 py-5 rounded-full font-medium text-xl hover:bg-white transition-all duration-300 shadow-[0_0_30px_rgba(245,208,169,0.3)] hover:shadow-[0_0_40px_rgba(255,255,255,0.5)] hover:-translate-y-1 flex items-center justify-center gap-3 mx-auto mb-8 inline-flex" data-id="element-183">
              Get The 3:00 AM Sleep Fix Now
            </a>

            <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-slate-400 font-light" data-id="element-184">
              <div className="flex items-center gap-2" data-id="element-185">
                <Download className="w-4 h-4" data-id="element-186" />
                <span data-id="element-187">Instant Digital Access</span>
              </div>
              <div className="hidden md:block w-1 h-1 rounded-full bg-slate-600" data-id="element-188" />
              <div className="flex items-center gap-2" data-id="element-189">
                <Lock className="w-4 h-4" data-id="element-190" />
                <span data-id="element-191">Secure Checkout</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}